var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.5 26V6C26.5 4.89543 25.6046 4 24.5 4L8.5 4C7.39543 4 6.5 4.89543 6.5 6V26C6.5 27.1046 7.39543 28 8.5 28H24.5C25.6046 28 26.5 27.1046 26.5 26Z",
    fill: "#E85D04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 26V6C26.5 4.89543 25.6046 4 24.5 4L8.5 4C7.39543 4 6.5 4.89543 6.5 6V26C6.5 27.1046 7.39543 28 8.5 28H24.5C25.6046 28 26.5 27.1046 26.5 26Z",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8H20.5",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceTablet);
export default __webpack_public_path__ + "static/media/DeviceTablet.655f993f3fa18b27ba8a262a00a85766.svg";
export { ForwardRef as ReactComponent };